import { Popover, TextButton, Text, Divider } from 'wix-style-react';
import * as React from 'react';
import s from './header-desktop-user-details.scss';
import { composer } from '../../../../component-decorators/composer';
import { HeaderUserImage } from '../header-user-image';
import { ChevronDown } from 'wix-ui-icons-common';
import { HeaderDesktopLanguagesPopover } from './header-desktop-languages-popover/header-desktop-languages-popover';
export var HeaderDesktopUserDetails = function (_a) {
    var username = _a.username, logoutLink = _a.logoutLink;
    var _b = React.useState(false), popoverOpen = _b[0], setPopoverOpen = _b[1];
    var flipPopoverOpen = function () {
        setPopoverOpen(!popoverOpen);
    };
    return (React.createElement(Popover, { animate: true, appendTo: "window", flip: true, onClick: flipPopoverOpen, onClickOutside: flipPopoverOpen, placement: "bottom-end", showArrow: true, shown: popoverOpen, theme: "light", className: s.popover },
        React.createElement(Popover.Element, null,
            React.createElement("div", { className: s.popoverElement },
                React.createElement(TextButton, { as: "button", dataHook: "user-image", skin: "dark", prefixIcon: React.createElement(HeaderUserImage, null), suffixIcon: React.createElement(ChevronDown, null) }, username))),
        React.createElement(Popover.Content, null,
            React.createElement(DesktopUserDetailsMenuContent, { logoutLink: logoutLink }))));
};
var DesktopUserDetailsMenuContent = composer()
    .withMarketplaceStore()
    .withExperiments()
    .compose(function (_a) {
    var marketplaceStore = _a.marketplaceStore, logoutLink = _a.logoutLink, experiments = _a.experiments;
    var shouldShowLanguagesSelector = experiments.enabled('specs.marketplace.use-new-marketplace');
    var showIndonesianLanguages = experiments.enabled('specs.marketplace.addIndonesianLanguage');
    return (React.createElement("div", { className: s.popoverContentContainer },
        React.createElement("div", { className: s.popoverContent },
            React.createElement("div", { className: s.userDetails },
                React.createElement(HeaderUserImage, { size: "48px", marginLeft: "0" }),
                React.createElement("div", { className: s.userDetailsText },
                    React.createElement(Text, { weight: "bold", ellipsis: true, showTooltip: false }, marketplaceStore.userName),
                    React.createElement(LogoutLink, { signoutLink: logoutLink }))),
            shouldShowLanguagesSelector && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s.divider },
                    React.createElement(Divider, null)),
                React.createElement(HeaderDesktopLanguagesPopover, { showLanguages: showIndonesianLanguages }))))));
});
var LogoutLink = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, signoutLink = _a.signoutLink;
    return (React.createElement(TextButton, { as: "a", href: signoutLink, dataHook: "logout" }, t('standalone.header.logout')));
});
//# sourceMappingURL=header-desktop-user-details.js.map